import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { HorizontalDivider } from './HorizontalDivider';

export const  RowDivider = () => {
  return <Row><Col className="p-0"><HorizontalDivider /></Col></Row>
}
